import * as CL from '@design-system/component-library';
import { dsClass } from '../../../common/constants/dsClasses.js';
import { changeOfDeviceMsg, t } from '../../../common/i18n/index.js';
import { getEppActionLocalization } from './eppDeviceChangeUtil.js';
import type { DeliveryOrder } from '../../../generated/api/deliveryOrder.js';
import type { Subscription } from '../../../generated/api/subscription.js';

export interface EppDeviceChangeSummaryProps {
  newEppProduct: DeliveryOrder;
  currentEppProduct: Subscription;
}

export const EppDeviceChangeSummary = ({ newEppProduct, currentEppProduct }: EppDeviceChangeSummaryProps) => {
  const eppAction = getEppActionLocalization(currentEppProduct.details?.device?.replacementAction);
  const currentProductName = currentEppProduct.subscriptionName;
  const replacementProductName = newEppProduct.deliveryOrderName;

  return (
    <CL.Disclaimer
      title={t.ZHBT(changeOfDeviceMsg)}
      icon={<CL.Icon icon="update" color="blue-600" />}
      className={`${dsClass.BACKGROUND_COLOR_BLUE_100} ${dsClass.MARGIN_BOTTOM_5}`}
      visible
    >
      <div className={dsClass.TEXT_S}>
        {eppAction}: {currentProductName}
      </div>
      <div className={dsClass.TEXT_S}>
        {t.OL3F('Replacement')}: {replacementProductName}
      </div>
    </CL.Disclaimer>
  );
};
